export const SECURITE_LESSONS_AR = [
  {
    id: 'securite-1',
    numero: 1,
    titre: "إنشاء كلمة مرور قوية",
    sousTitre: "حماية حساباتك",
    contexte: "كلمة مرورك هي مفتاح حساباتك. كيف تختار كلمة مرور قوية وسهلة التذكر في نفس الوقت؟",
    explication: [
      "**12 حرفاً على الأقل**: كلما كانت أطول، كانت أصعب للاختراق. 12 حرف هو الحد الأدنى الموصى به.",
      "**طريقة الكلمات الثلاث**: اختر 3 كلمات عشوائية وارفق بينها — مثلاً 'شجرة!سيارة#قمر2026'. سهلة للتذكر وصعبة للاختراق.",
      "**لا تستخدم**: اسمك، تاريخ ميلادك، '123456'، 'azerty' — هذه أول ما يجرّبه المخترقون.",
      "**كلمة مرور لكل حساب**: لا تستخدم نفس الكلمة في كل مكان. إذا اختُرق موقع واحد، باقي حساباتك بأمان.",
      "**مدير كلمات المرور**: تطبيقات مثل Bitwarden (مجاني) تخزّن كل كلمات مرورك بأمان — لا تحتاج تذكّرها.",
    ],
    question: "ما هو الحد الأدنى الموصى به لطول كلمة المرور؟",
    options: [
      { id: 'a', text: "12 حرفاً", correct: true },
      { id: 'b', text: "6 أحرف", correct: false },
      { id: 'c', text: "8 أحرف", correct: false },
    ],
    explication_reponse: "12 حرف هو الحد الأدنى للأمان الجيد. كلمة مرور بـ 12 حرف عشوائي تحتاج آلاف السنين للاختراق بالقوة.",
  },
  {
    id: 'securite-2',
    numero: 2,
    titre: "التعرف على الاحتيال الإلكتروني",
    sousTitre: "لا تقع في الفخ",
    contexte: "رسالة SMS أو بريد إلكتروني يخبرك بطرد أو غرامة أو جائزة... كيف تعرف الاحتيال؟",
    explication: [
      "**احتيال الطرود**: رسالة 'طردك في الانتظار، ادفع 2 أورو لاسترداده'. إذا لم تنتظر طرداً، تجاهلها تماماً.",
      "**احتيال الغرامة**: SMS يدّعي أنك مدين لمخالفة مرورية أو ضريبية مع رابط للدفع. الجهات الرسمية لا تُرسل روابط دفع عبر SMS.",
      "**علامات الاحتيال**: إلحاح ('انتهز الفرصة قبل 24 ساعة')، أخطاء إملائية، روابط غريبة، طلب بيانات بنكية.",
      "**للإبلاغ**: أرسل الرسالة المشبوهة إلى 33700 (SMS) أو signal-spam.fr (بريد إلكتروني). مجاني ومهم.",
      "**في حالة شك**: لا تنقر على أي رابط — اذهب مباشرة إلى الموقع الرسمي للتحقق.",
    ],
    question: "تلقيت SMS يطلب دفع 2 أورو لاسترداد طرد. ماذا تفعل؟",
    options: [
      { id: 'a', text: "تجاهله وأبلّغ عنه على 33700", correct: true },
      { id: 'b', text: "ادفع المبلغ إذا كنت تنتظر طرداً", correct: false },
      { id: 'c', text: "انقر على الرابط للتحقق", correct: false },
    ],
    explication_reponse: "هذا احتيال كلاسيكي. شركات الشحن الحقيقية لا تطلب دفعاً عبر SMS برابط. أبلّغ عنه على 33700 — رقم مجاني للإبلاغ عن الاحتيال.",
  },
  {
    id: 'securite-3',
    numero: 3,
    titre: "حماية بياناتك الشخصية",
    sousTitre: "ما تشاركه وما لا تشاركه",
    contexte: "الإنترنت يطلب باستمرار بياناتك. كيف تحمي معلوماتك الشخصية؟",
    explication: [
      "**مبدأ التقليل**: لا تعطِ من بياناتك إلا ما هو ضروري حقاً. موقع لمقارنة الأسعار لا يحتاج رقم هاتفك.",
      "**القفل الأخضر 🔒**: تحقق من وجوده في شريط العنوان (https) قبل إدخال أي معلومة حساسة — يعني الاتصال مشفَّر.",
      "**RGPD**: القانون الأوروبي يمنحك حق معرفة وتصحيح وحذف بياناتك الشخصية لدى أي موقع.",
      "**الشبكات الاجتماعية**: اضبط إعدادات الخصوصية على 'أصدقاء فقط'. لا تنشر صور وثائقك الرسمية.",
      "**الشبكات العامة WiFi**: لا تدخل إلى حساباتك البنكية أو الإدارية على شبكة WiFi عامة (مقهى، مطار).",
    ],
    question: "ما الذي يعنيه القفل الأخضر 🔒 في شريط عنوان موقع ويب؟",
    options: [
      { id: 'a', text: "الاتصال مشفَّر وبياناتك في أمان", correct: true },
      { id: 'b', text: "الموقع رسمي ومعتمد من الحكومة", correct: false },
      { id: 'c', text: "الموقع مجاني للاستخدام", correct: false },
    ],
    explication_reponse: "القفل يعني أن الاتصال بين هاتفك والموقع مشفَّر — لا أحد يمكنه اعتراض بياناتك. لكنه لا يعني بالضرورة أن الموقع موثوق — فقط أن الاتصال آمن.",
  },
  {
    id: 'securite-4',
    numero: 4,
    titre: "ماذا تفعل في حالة مشكلة؟",
    sousTitre: "خطوات الطوارئ",
    contexte: "اعتقدت أنك وقعت في فخ احتيال أو اختُرق حسابك. ماذا تفعل الآن؟",
    explication: [
      "**غيّر كلمة مرورك فوراً**: إذا شككت في اختراق حساب، غيّر كلمة مروره على الفور من جهاز آخر.",
      "**اتصل ببنكك**: إذا أعطيت بياناتك البنكية، اتصل بمصرفك فوراً لتجميد البطاقة. الرقم مكتوب على ظهر بطاقتك.",
      "**cybermalveillance.gouv.fr**: الموقع الرسمي الفرنسي للمساعدة في حالات الاختراق والاحتيال الرقمي — مجاني.",
      "**الإفادة للشرطة**: للاحتيال المالي، اذهب إلى مخفر الشرطة أو Gendarmerie لتقديم بلاغ رسمي. ضروري للمطالبة بالتعويض.",
      "**لا تدفع الفدية**: إذا طُلب منك دفع مبلغ لاسترداد ملفاتك المشفَّرة (ransomware)، لا تدفع — اتصل بـ cybermalveillance.gouv.fr.",
    ],
    question: "اكتشفت أن حسابك البنكي ربما تعرّض للاختراق. ما هي الخطوة الأولى؟",
    options: [
      { id: 'a', text: "الاتصال ببنكك فوراً لتجميد البطاقة", correct: true },
      { id: 'b', text: "انتظار رسالة من البنك قبل التصرف", correct: false },
      { id: 'c', text: "تغيير كلمة مرور البريد الإلكتروني أولاً", correct: false },
    ],
    explication_reponse: "البنك هو أول من تتصل به في حالة الاشتباه بسرقة البيانات البنكية. يمكنه تجميد البطاقة فوراً لمنع أي عملية غير مشروعة.",
  },
];
